import { apiSlice } from 'app/api/apiSlice'
import { removeEmptyKeys } from 'utilities'

export const bouserApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBousers: builder.query({
      query: ({ page, limitNumber, params }) => {
        return {
          url: `/bouser/${page}/params`,
          params: { limitNumber, ...removeEmptyKeys(params) },
        }
      },
      transformResponse: (response, meta, args) => {
        let parsedBoUsers = response.BOUserList.map((user) => {
          return {
            ...user.user,
            ...user.role[0],
          }
        })
        return {
          rows: parsedBoUsers,
          count: response.count,
          pages: response.pages,
        }
      },
      providesTags: ['bouser'],
    }),
    toggleBouserAble: builder.mutation({
      query: ({ id: bouserid, able }) => {
        return {
          url: '/bouser/able',
          method: 'PUT',
          body: { bouserid: bouserid, able: able ? 'true' : 'false' },
        }
      },
      invalidatesTags: ['bouser'],
    }),
    createBouser: builder.mutation({
      /**
       * creates a new BOUser and sends and invitation email to the user, the user must accept the invitation and finish the registration process
       * @param {*} param0
       * @returns
       */
      query: ({ firstname, lastname, email, roleid }) => {
        return {
          url: '/bouser/',
          method: 'POST',
          body: {
            user: { firstname, lastname, email },
            roles: [{ roleid: roleid }],
          },
        }
      },
      invalidatesTags: ['bouser'],
    }),
    registerBouser: builder.mutation({
      /**
       * finish the registration of a new bouser accesible after the invitation email
       * @param {*} param0
       * @returns
       */
      query: ({ phone, password, twofa }) => {
        return {
          url: '/bouser/',
          method: 'PUT',
          body: { user: { phone, password, twofa } },
        }
      },
      invalidatesTags: ['bouser'],
    }),
    updateBouser: builder.mutation({
      /**
       * Update of user data from a different user with an authorized role
       * @param {object} - user data
       * @returns
       */
      query: ({ id, firstname, lastname, email,phone, password, twofa, roleid }) => {
        return {
          url: '/bouser/'+id,
          method: 'PUT',
          body: { user: { firstname, lastname, email, phone, password, twofa }, roles: [{ roleid: roleid }] },
        }
      },
      invalidatesTags: ['bouser'],
    }),
    resendInvitation: builder.mutation({
      /**
       * Resend invitation email to a user
       * @param {object} - bouserid
       */
      query: ({ bouserid }) => {
        return {
          url: '/bouser/resendinvitation',
          method: 'POST',
          body: { bouserid },
        }
      }
    }) 
  }),
  overrideExisting: true,
})

export const {
  useGetBousersQuery,
  useToggleBouserAbleMutation,
  useCreateBouserMutation,
  useRegisterBouserMutation,
  useUpdateBouserMutation,
  useResendInvitationMutation,
} = bouserApiSlice
